import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ComparisonArticle from "@/pages/comparison/page";
import SafetyArticle from "@/pages/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-kakobuy",
    element: <ComparisonArticle />,
  },
  {
    path: "/hipobuy-spreadsheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;